import React from "react"

import PersonGroup    from "../../../types/PersonGroup"
import ItemViewHeader from "../../common/Headers/ItemViewHeader"
import IconPersonGroup from "../../common/Icons/PersonGroup";

export interface componentProps {
    item: PersonGroup
}

const Header: React.FC<componentProps> = ({item}) => {

    const
        linkSegment = item.dataSourceId ? 'view' : 'form',
        text = item.name

    return <ItemViewHeader
        icon={<IconPersonGroup link={'/person-groups/' + item.id + '/' + linkSegment} text={text} />}
        title={text}
        subTitle={item.description || ''}
    />

}

export default Header